import React, { useContext, useState } from "react";
import PropTypes from "prop-types";
import { Menu, Layout } from "antd";
import {
	UploadOutlined,
	UserOutlined,
	VideoCameraAddOutlined,
} from "@ant-design/icons";
import { setHomeLogo } from "../utils/company_logo";
import { GetAntIcon } from "../utils/ant_icons";
import { logout } from "../utils/utils";
import { superAdminRole } from "../utils/_exports";
import { useNavigate } from "react-router";
import Emitter from "../utils/emitter";
import { MenuItem } from "@mui/material";
import { HomeContext } from "../containers/Home";

const { Sider } = Layout;

export const initialMainMenu: any = [
	{
		key: "dashboard-menu",
		label: "Dashboard",
		propTitle: "Dashboard",
		container: "dashboard",
		icon: GetAntIcon("global"),
		to: "/dashboard",
	},
	{
		key: "project-menu",
		label: "Projects",
		propTitle: "Projects",
		container: "projects",
		icon: GetAntIcon("project"),
		to: "/projects",
		child: [
			{
				propTitle: "Add new project",
				to: "/add-new-project",
				key: "add-new-project",
			},
			{
				propTitle: "Project settings",
				to: "/project-settings",
				key: "project-settings",
			},
			{
				propTitle: "Well settings",
				to: "/well-settings",
				key: "Well settings",
			},
		],
	},
];

export const initialExtraMenu: any = [
	{
		key: "help-menu",
		label: "Help center",
		propTitle: "Help center",
		className: "extra-menu-item",
		container: "helpCenter",
		to: "/help-center",
		icon: GetAntIcon("question3"),
	},
	{
		key: "notification-menu",
		label: "Notifications",
		propTitle: "Notifications",
		className: "extra-menu-item",
		icon: GetAntIcon("bell"),
	},
	{
		key: "admin-menu",
		label: "Administration",
		propTitle: "Administration",
		className: "extra-menu-item",
		container: "admin",
		to: "/administration",
		icon: GetAntIcon("setting"),
		requires_admin: true,
		// children: [
		// 	{
		// 		key: "lookup-manager",
		// 		label: "Lookup manager",
		// 		propTitle: "Lookup manager",
		// 		container: "lookupManager",
		// 		requires_admin: true,
		// 		to: "/lookup-manager",
		// 	},
		// 	{
		// 		key: "role-manager",
		// 		label: "Role manager",
		// 		propTitle: "Role manager",
		// 		container: "roleManager",
		// 		requires_admin: true,
		// 		to: "/role-manager",
		// 	},
		// ],
	},
	{
		key: "profile-menu",
		label: "Profile",
		propTitle: "Profile",
		icon: GetAntIcon("user"),
		className: "extra-menu-item",
		children: [
			{
				key: "user-profile",
				label: "My profile",
				propTitle: "My profile",
				container: "profile",
				to: "/profile",
			},
			{
				key: "manage-account",
				label: "Manage account",
				propTitle: "Manage account",
			},
			{ key: "some-divider", type: "divider" },
			{ key: "logout", label: "Sign out", propTitle: "Sign out" },
		],
	},
];

const MainMenu = (props: any) => {
	const context: any = useContext(HomeContext);
	const navigate = useNavigate();
	const [selectedKeys, setSelectedKeys] = useState<any>([]);

	const renderMenu = () => {
		const createMainMenu = (roles: any) => {
			return initialMainMenu.map((menuItem: any) => {
				if (menuItem.requires_admin == true) {
					if (roles?.includes(superAdminRole)) {
						return menuItem;
					} else {
						return null;
					}
				} else {
					return menuItem;
				}
			});
		};

		const handleMainMenu = async (info: any) => {
			try {
				await context.handlePageChange();
				sessionStorage.removeItem("main-tabkey");
				sessionStorage.removeItem("admin-tabkey");
				sessionStorage.removeItem("tabkey");
				if (info.item.props.to) {
					setSelectedKeys([info.key]);
					Emitter.emit("menuChange", [info.item.props]);
					navigate(info.item.props.to);
				}
			} catch {}
		};
		return (
			<Menu
				className="main-menu"
				mode="inline"
				defaultSelectedKeys={["dashboard-menu"]}
				selectedKeys={props.selectedKey || selectedKeys}
				items={createMainMenu(props.roles)}
				onClick={(info: any) => {
					handleMainMenu(info);
				}}
			></Menu>
		);
	};

	const renderExtraMenu = () => {
		const createExtraMenu = (roles: any) => {
			return initialExtraMenu.map((menuItem: any) => {
				if (menuItem.requires_admin == true) {
					if (roles?.includes(superAdminRole)) {
						return menuItem;
					} else {
						return null;
					}
				} else {
					return menuItem;
				}
			});
		};
		const handleExtraMenu = async (info: any) => {
			try {
				await context.handlePageChange();
				sessionStorage.removeItem("admin-tabkey");
				sessionStorage.removeItem("tabkey");
				if (info.item.props.to) {
					Emitter.emit("menuChange", [info.item.props]);
					setSelectedKeys([info.key]);
					if (info.item.props.requires_admin) {
						// navigate("/admin" + info.item.props.to);
						navigate(info.item.props.to);
					} else {
						navigate(info.item.props.to);
					}
				}
				if (info.key === "logout") {
					localStorage.removeItem("idToken");
					localStorage.removeItem("accessToken");
					logout();
				}
				if (info.key === "manage-account") {
					window.open(
						"https://myaccount.microsoft.com/?ref=MeControl",
						"_blank"
					);
				}
			} catch {}
		};

		return (
			<Menu
				selectedKeys={props.selectedKey || selectedKeys}
				className="extra-menu"
				style={{ marginTop: "auto" }}
				mode="inline"
				items={createExtraMenu(props.roles)}
				onClick={(info: any) => {
					handleExtraMenu(info);
				}}
			></Menu>
		);
	};

	return (
		<>
			{props.option != "Mega" ? (
				<Sider
					className="main-sider"
					collapsed={props.collapsed}
					onCollapse={props.onCollapse}
					collapsible
				>
					<div
						style={{
							display: "flex",
							justifyContent: "center",
							marginTop: "20px",
							marginBottom: "15px",
						}}
					>
						{setHomeLogo()}
					</div>
					{renderMenu()}
					{renderExtraMenu()}
				</Sider>
			) : (
				<></>
			)}
		</>
	);
};

MainMenu.propTypes = {
	collapsed: PropTypes.bool,
	onCollapse: PropTypes.func,
	option: PropTypes.any,
	roles: PropTypes.array,
	selectedKey: PropTypes.any,
};

export default MainMenu;
